import React from 'react';

import classNames from 'classnames';

import BaseInput, { Props as BaseProps } from './BaseInput';

type Props = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement> &
    BaseProps & {
      label: string;
    },
  HTMLInputElement
>;

export const CheckboxInput = React.forwardRef<HTMLInputElement, Props>(
  ({ className, disabled, label, error, ...props }, ref) => {
    return (
      <label className="relative flex items-center justify-start w-full h-full py-3 cursor-pointer">
        <span className="flex items-center">
          <BaseInput
            ref={ref}
            error={error}
            type="checkbox"
            disabled={disabled}
            className={classNames(
              className,
              'h-5 w-5 focus:outline-none focus:ring-primary text-primary border-2 border-gray-dark500 bg-gray-dark600 rounded-md cursor-pointer',
              {
                'border-gray-dark600 bg-gray-dark800': disabled,
              }
            )}
            {...props}
          />
        </span>
        <span
          className={classNames('ml-3 text-sm font-medium cursor-pointer w-full', {
            'text-gray-dark400 opacity-30': disabled,
            'text-gray-dark400': props.checked,
            'text-gray-dark500': !props.checked,
          })}
        >
          {label}
        </span>
      </label>
    );
  }
);

export default CheckboxInput;
